import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CopyAllIcon(props: IconProps) {
    return <Icon {...props} iconKey={"copy_all"}/>
}
